import { get , post } from './api';

export const userControl = {
	// 登录
	login:(data) => post('?c=login&m=loginUsers', data),
	// 左侧导航
	slide_bar:(data) => post('?c=d_three_api&m=columnList', data),
}
// 组织概况
export const zzgk = {
	// 传入user_id  flag   year
	zzgkData:(data) => post('?c=d_three_api&m=organProfile', data),
	// 修改党委信息   
	editDw:(data) => post('?c=d_three_api&m=updateDw', data),
}

// 组织生活
export const zzsh = {
	// 谈心谈话列表
	organTalkList:(data) => post('?c=d_three_api&m=organTalkList', data),
	// 新增谈心谈话
	addOrganTalk:(data) => post('?c=d_three_api&m=addOrganTalk', data),
	// 编辑谈心谈话
	updateOrganTalk:(data) => post('?c=d_three_api&m=updateOrganTalk', data),
	// 删除谈心谈话
	delOrganTalk:(data) => post('?c=d_three_api&m=delOrganTalk', data),
	// 党委谈心谈话文件上传
	addTalkFiles:(data) => post('?c=d_three_api&m=addTalkFiles', data),
	// 党委谈心谈话文件列表
	talkFilesList:(data) => post('?c=d_three_api&m=talkFilesList', data),
	// 删除党委谈心谈话文件
	delTalkFiles:(data) => post('?c=d_three_api&m=delTalkFiles', data),
	// 谈心谈话详情
	updateOrganTalkGet:(data) => get('?c=d_three_api&m=updateOrganTalk&id='+data.id),
	// 民主评议列表
	appraiseList:(data) => post('?c=d_three_api&m=appraiseList', data),
	// 党员评议
	appraiseAudit:(data) => post('?c=d_three_api&m=appraiseAudit', data),
	// 一键清空
	clearAppraise:(data) => post('?c=d_three_api&m=clearAppraise', data),
	// 党委上传文件
	addAppraiseFiles:(data) => post('?c=d_three_api&m=addAppraiseFiles', data),
	// 党委文件列表
	appraiseFilesList:(data) => post('?c=d_three_api&m=appraiseFilesList', data),
	// 删除党委文件
	delAppraiseFiles:(data) => post('?c=d_three_api&m=delAppraiseFiles', data),
	// 民主评议-支部讲评/上级评价
	appraiseAudit2:(data) => post('?c=d_three_api&m=appraiseAudit2', data),
	// 民主评议-党员详情
	appraiseMemberDetail:(data) => post('?c=d_three_api&m=appraiseMemberDetail', data),
	// 民主评议-党员详情-上传材料
	addAppraiseMemberFile:(data) => post('?c=d_three_api&m=addAppraiseMemberFile', data),
	// 民主评议-党员详情-删除材料
	delAppraisalMemberFiles:(data) => post('?c=d_three_api&m=delAppraiseMemberFiles', data),
	// 思想汇报列表
	thoughtList:(data) => post('?c=d_three_api&m=thoughtList', data),
	// 思想汇报删除所有文件
	delAllThought:(data) => post('?c=d_three_api&m=delAllThought', data),
	// 思想汇报个人文件列表
	thoughtMemberDetail:(data) => post('?c=d_three_api&m=thoughtMemberDetail', data),
	// 思想汇报个人文件新增
	addThought:(data) => post('?c=d_three_api&m=addThought', data),
	// 思想汇报个人文件删除
	delThoughtFile:(data) => post('?c=d_three_api&m=delThoughtFile', data),
	// 思想汇报个人文件编辑
	updateThought:(data) => post('?c=d_three_api&m=updateThought', data),
	// 思想汇报个人文件详情
	updateThoughtGet:(data) => get('?c=d_three_api&m=updateThought&id='+data.id),
	// 一键签到   
	allSign:(data) => post('?c=d_three_api&m=allSign', data),
}

// 党员教育
export const dyjy = {
	// 制定计划列表
	zdjhList:(data) => post('?c=d_three_api&m=yearPlanList',data),
	// 复制年度计划
	copyYearPlan:(data) => post('?c=d_three_api&m=copyYearPlan',data),
	// 编辑年度计划
	zdjhUpdate:(data) => post('?c=d_three_api&m=updateYearPlan',data),
	// 新增年度计划文件
	addPlanFile:(data) => post('?c=d_three_api&m=addPlanFile',data),
	// 编辑年度计划文件绑定
	updatePlanFileGet:(data) => get('?c=d_three_api&m=updatePlanFile&id='+data.id+'&type='+data.type),
	// 编辑提交年度计划文件
	updatePlanFile:(data) => post('?c=d_three_api&m=updatePlanFile',data),
	// 删除年度计划文件
	delPlanFile:(data) => post('?c=d_three_api&m=delPlanFile',data),
	// 编辑年度计划绑定
	zdjhUpdateGet:(data) => get('?c=d_three_api&m=updateYearPlan&id='+data.id),
	// 清空当前计划资源
	clearPlanFile:(data) => post('?c=d_three_api&m=clearPlanFile',data),
	// 制定计划详情列表
	zdjhDetailList:(data) => post('?c=d_three_api&m=planFileList',data),
	// 督办提醒列表
	oversee:(data) => post('?c=d_three_api&m=oversee',data),
	// 提醒
	sendOversee:(data) => post('?c=d_three_api&m=sendOversee',data),
	// 上传介绍信或回执
	transferIntroduce:(data) => post('?c=d_three_api&m=transferIntroduce',data),
	// 介绍信详情
	introduceDetail:(data) => post('?c=d_three_api&m=introduceDetail',data),
}

/* 党务工作 */
 
export const dwgl = {
	// 党费统计
	dftj:(data) => post('?c=d_three_api&m=parties2', data),
	// 删除党费统计
	dftjDel:(data) => post('?c=d_three_api&m=delParties', data),
	// 导出表格
	dftjDaochu:(data) => post('?c=d_three_api&m=exportPartyOrgan', data),
	// 党员列表
	dyList:(data) => post('?c=d_three_api&m=memberAdmin', data),
	// 组织类型列表
	organClass:() => get('?c=d_three_api&m=organClass').then(res => {
		return res.data
	}),
	// 上级组织
	pOrgan:(data) => post('?c=d_three_api&m=pOrgan', data),
	// 删除组织
	delOrgan:(data) => post('?c=d_three_api&m=delOrgan', data),
	// 新增党组织
	addOrgan:(data) => post('?c=d_three_api&m=addOrgan', data),
	// 支部列表有分页
	partyOrgan:(data) => post('?c=d_three_api&m=partyOrgan2', data),
	// 查看党组织数据
	updateOrgan:(data) => get('?c=d_three_api&m=updateOrgan&id='+data.id+'&flag='+data.flag+'&pid='+data.p_id),
	// 导出党组织详情页表格
	exportPartyOrgan:(data) => post('?c=d_three_api&m=exportPartyOrgan', data).then(res => {
		window.location.href = res.link;
	}),
	// 编辑支部信息
	updateOrgan1:(data) => post('?c=d_three_api&m=updateOrgan', data),
	// 查看党组织成员
	memberAdmin:(data) => post('?c=d_three_api&m=memberAdmin',data),
	// 活动记录
	activity:(data) => post('?c=d_three_api&m=activity',data),
	// 删除活动
	delActivity:(data) => post('?c=d_three_api&m=delActivity',data),
	// 活动人员选择
	organMember:(data) => post('?c=d_three_api&m=organMember',data),
	// 活动类型列表
	hyClass:() => get('?c=d_three_api&m=hyClass').then(res => {
		return res.data
	}),
	// 新增活动
	addActivity:(data) => post('?c=d_three_api&m=addActivity',data),
	// 编辑活动数据绑定
	updateActivity:(data) => get('?c=d_three_api&m=updateActivity&flag='+data.flag+'&hyid='+data.hyid+'&pub_flag='+data.pub_flag),
	// 编辑提交
	updateActivity1:(data) => post('?c=d_three_api&m=updateActivity',data),
	// 提交会议记录
	addHyLog:(data) => post('?c=d_three_api&m=addHyLog',data),
	// 星级评定列表
	starApproval:(data) => post('?c=d_three_api&m=starApproval',data),
	// 星级规则更新
	starDefault:(data) => post('?c=d_three_api&m=starDefault&user_id='+data.user_id),
	// 星级规则列表
	updateStarRole:(data) => post('?c=d_three_api&m=updateStarRole',data),
	// 星级规则新增条目
	addStarRole:(data) => post('?c=d_three_api&m=addStarRole',data),
	// 党委重新打分
	starDoApproval:(data) => post('?c=d_three_api&m=starDoApproval',data),
	// 优秀党员/党务工作者评分细则新增
	addGoodMemberType:(data) => post('?c=d_three_api&m=addGoodMemberType',data),
	// 优秀党员/党务工作者评分细则编辑
	updateGoodMemberType:(data) => post('?c=d_three_api&m=updateGoodMemberType',data),
	
	// 经费下拨列表
	funds:(data) => post('?c=d_three_api&m=funds',data),
	// 新增党费
	addParties:(data) => post('?c=d_three_api&m=addParties',data),
	// 清空党费
	clearParties:(data) => post('?c=d_three_api&m=clearParties',data),
	// 批量新增党费
	excelPutData:(data) => post('?c=d_three_api&m=excelPutData',data),
	// 编辑党费
	updateParties:(data) => post('?c=d_three_api&m=updateParties',data),
	// 新增经费下拨
	addFunds:(data) => post('?c=d_three_api&m=addFunds',data),
	// 经费下拨修改
	updateFunds:(data) => post('?c=d_three_api&m=updateFunds',data),
	// 经费删除
	delFunds:(data) => post('?c=d_three_api&m=delFunds',data),
	// 组织所在地列表
	provinceList:(data) => post('?c=d_three_api&m=provinceList',data),
	// 新增组织所在地列表
	addProvince:(data) => post('?c=d_three_api&m=addProvince',data),
	// 台账经费单位列表
	standCompany:(data) => post('?c=d_three_api&m=standCompany',data),
	// 台账经费列表
	standPartiesList:(data) => post('?c=d_three_api&m=standPartiesList',data),
	// 删除台账经费
	delStandParties:(data) => post('?c=d_three_api&m=delStandParties',data),
	// 新增台账经费
	addStandParties:(data) => post('?c=d_three_api&m=addStandParties',data),
	// 编辑台账经费
	updateStandParties:(data) => post('?c=d_three_api&m=updateStandParties',data),
	// 导出台账
	exportStandParites:(data) => post('?c=d_three_api&m=exportStandParites',data).then(res => {
		window.location.href = res.link;
	}),
	// 党务公开列表
	partyAffairsList:(data) => post('?c=d_three_api&m=partyAffairsList',data),
	// 新增党务公开
	addPartyAffairs:(data) => post('?c=d_three_api&m=addPartyAffairs',data),
	// 党务公开详情
	updatePartyAffairsGet:(data) => get('?c=d_three_api&m=updatePartyAffairs&id='+data.id),
	// 编辑党务公开
	updatePartyAffairs:(data) => post('?c=d_three_api&m=updatePartyAffairs',data),
	// 删除党务公开
	delPartyAffairs:(data) => post('?c=d_three_api&m=delPartyAffairs',data),

	// 优秀党员列表
	goodMemberList:(data) => post('?c=d_three_api&m=goodMemberList',data),
	// 新增候选人
	addGoodMember:(data) => post('?c=d_three_api&m=addGoodMember',data),
	// 评分项
	goodMemberType:(data) => get('?c=d_three_api&m=goodMemberType&status='+data.status+'&user_id='+data.user_id),
	// 打分优秀党员
	scoreGoodMember:(data) => post('?c=d_three_api&m=scoreGoodMember',data),
	// 删除优秀党员
	delGoodMember:(data) => post('?c=d_three_api&m=delGoodMember',data),
	// 优秀工作者列表
	goodLeaderList:(data) => post('?c=d_three_api&m=goodLeaderList',data),
	// 优秀党员/党务工作者附件列表
	goodMemberTypeFileList:(data) => post('?c=d_three_api&m=goodMemberTypeFileList',data),
	// 优秀党员/党务工作者附件上传
	goodMemberAddTypeFile:(data) => post('?c=d_three_api&m=goodMemberAddTypeFile',data),
	// 优秀党员/党务工作者附件删除
	delGoodMemberTypeFile:(data) => post('?c=d_three_api&m=delGoodMemberTypeFile',data),
	// 星级评定附件列表
	roleTypeFileList:(data) => post('?c=d_three_api&m=roleTypeFileList',data),
	// 星级评定上传附件
	roleAddTypeFile:(data) => post('?c=d_three_api&m=roleAddTypeFile',data),
	// 星级评定附件删除
	delRoleTypeFile:(data) => post('?c=d_three_api&m=delRoleTypeFile',data),
}
// 党建宣传
export const djxc = {
	// 支部要闻
	zbNews:(data) => post('?c=d_three_api&m=news', data),
	// 支部要闻详情
	zbNewsDetail:(data) => get('?c=d_three_api&m=updateNews&id='+data),
	// 新增支部要闻
	zbNewsAdd:(data) => post('?c=d_three_api&m=addNews',data),
	// 编辑支部要闻
	zbNewsUpdate:(data) => post('?c=d_three_api&m=updateNews',data),
	// 编辑支部要闻
	zbNewsUpdateGet:(data) => get('?c=d_three_api&m=updateNews&id='+data.id),
	// 删除支部要闻
	zbNewsDel:(data) => post('?c=d_three_api&m=delNews',data),
	
	// 风采展示
	thearList:(data) => post('?c=d_three_api&m=thearList', data),
	// 新增风采展示
	addThear:(data) => post('?c=d_three_api&m=addThear', data),
	// 编辑风采展示
	updateThear:(data) => post('?c=d_three_api&m=updateThear', data),
	// 风采展示获取数据
	updateThearGet:(data) => get('?c=d_three_api&m=updateThear&id='+data.id+'&type='+data.type),
	// 删除支部风采
	delThear:(data) => post('?c=d_three_api&m=delThear',data),
	// 支部列表无分页
	partyOrgan:(data) => post('?c=d_three_api&m=partyOrgan', data),
	// 新增支部风采
	zbfcAdd:(data) => post('?c=d_three_api&m=addZbfc',data),
	// 编辑支部风采
	zbfcUpdate:(data) => post('?c=d_three_api&m=updateZbfc',data),
	
	// 党员风采
	dyfc:(data) => post('?c=d_three_api&m=dyfc', data),
	// 党员风采详情
	dyfcDetail:(data) => get('?c=d_three_api&m=updateDyfc&id='+data),
	// 新增党员风采
	dyfcAdd:(data) => post('?c=d_three_api&m=addDyfc',data),
	// 编辑党员风采
	dyfcUpdate:(data) => post('?c=d_three_api&m=updateDyfc',data),
	// 删除党员风采
	dyfcDel:(data) => post('?c=d_three_api&m=delDyfc',data),

	// 宣传材料
	updatePropaganda:(data) => post('?c=d_three_api&m=updatePropaganda',data),
	// 宣传材料Get
	propagandaGet:(data) => get('?c=d_three_api&m=updatePropaganda&user_id='+data.user_id+'&flag='+data.flag),

	// 欢迎海报模板列表
	postersTemplate:(data) => post('?c=d_three_api&m=postersTemplate',data),
	// 欢迎海报模板列表
	addPosters:(data) => post('?c=d_three_api&m=posters',data),
	// 欢迎海报删除
	delPosters:(data) => post('?c=d_three_api&m=delPosters',data),
	// 欢迎海报删除
	usePosters:(data) => post('?c=d_three_api&m=usePosters',data),
	// 欢迎海报新建列表
	posters:(data) => get('?c=d_three_api&m=posters&flag='+data.flag+'&user_id='+data.user_id),
}


// 树形结构
export const treeData = {
	treeData:(data) => post('?c=d_three_api&m=childList', data),
}

// 资源库
export const databank = {
	// 资源分类
	resouceClass:() => get('?c=d_three_api&m=resouceClass', ),
	// 资源列表  class_id: 2 page: 1 title
	resouceList:(data) => post('?c=d_three_api&m=resouceAll ',data),
}

// 党员管理
export const dygl = {
	// 党员身份列表
	dyclass:() => {
		var arr = [
			{level:"书记",zhiwu:1},
			{level:"副书记",zhiwu:2},
			{level:"委员",zhiwu:3},
		]
		return arr
	},
	// 领导班子
	leaderList:(data) => post('?c=d_three_api&m=leaderList ',data),
	// 党员信息详情
	updateMemberBind:(data) => get('?c=d_three_api&m=updateMember&id='+data.id),
	// 党员信息详情
	excelPutData:(data) => post('?c=d_three_api&m=excelPutData',data),
	// 删除党员
	delMember:(data) => post('?c=d_three_api&m=delMember ',data),
	// 党员学习记录详情type: 4活动记录   1：集中学习  id: 党员id
	leaderHyLog:(data) => post('?c=d_three_api&m=leaderHyLog ',data),
	// 发展党员管理列表
	userDevelop:(data) => post('?c=d_three_api&m=userDevelop ',data),
	// 发展党员审核通过 uid: 4021 u_zhiwu_status: 15
	userHave:(data) => post('?c=d_three_api&m=userHave',data),
	// 党员转出列表
	transferOutList:(data) => post('?c=d_three_api&m=transferOutList',data),
	// 党员转入列表
	transferIntoList:(data) => post('?c=d_three_api&m=transferIntoList',data),
	// 党员转入详情
	transferDetail:(data) => post('?c=d_three_api&m=transferDetail',data),
	// 党员转出提交
	transferOut:(data) => post('?c=d_three_api&m=transferOut',data),
	// 党员转入通过
	transferExamine:(data) => post('?c=d_three_api&m=transferExamine',data),
	// 民族列表
	nation:(data) => get('?c=d_three_api&m=nation'),
	// 新增党员
	addMember:(data) => post('?c=d_three_api&m=addMember',data),
	// 编辑党员
	updateMember:(data) => post('?c=d_three_api&m=updateMember',data),
	// 扫码新增党员
	generateQrcode:(data) => get('?c=d_three_api&m=generateQrcode&zbid='+data),
	// 党员心得体会
	selectTips:(data) => post('?c=d_three_api&m=selectTips',data),
}

// 学习教育
export const xxjy = {
	// 支部学习记录列表
	branchStudyDetail:(data) => post('?c=d_three_api&m=branchStudyDetail',data),
	// 党员学习记录列表
	taskPersonStudy:(data) => post('?c=d_three_api&m=taskPersonStudy',data),
	// 专题资料库列表
	special:(data) => post('?c=d_admin_index&m=special',data),
	// 公开资源
	openParty:(data) => post('?c=d_three_api&m=openSpecial ',data),
	// 新增专题
	addSpecial:(data) => post('?c=d_three_api&m=addSpecial ',data),
	// // 专题编辑绑定
	// updateSpecial:(data) => get('?c=d_three_api&m=updateSpecial&id='+data.id),
	// // 专题编辑保存
	// updateSpecial1:(data) => post('?c=d_three_api&m=updateSpecial',data),
		// 专题编辑绑定
		updateSpecial:(data) => get('?c=d_three_api&m=updateSpecial&id='+data.id),
		// 专题编辑保存
		updateSpecial1:(data) => post('?c=d_three_api&m=updateSpecial',data),
	// 删除专题
	delSpecial:(data) => post('?c=d_three_api&m=delSpecial ',data),
	// // 专题内容
	// selectSpecialContent:(data) => post('?c=d_three_api&m=selectSpecialContent ',data),
		// 专题内容
		selectSpecialContent:(data) => post('?c=d_admin_index&m=selectSpecialContent ',data),
	// 专栏列表
	selectSpecialColumn:(data) => post('?c=d_three_api&m=selectSpecialColumn ',data),
	// 新增专题内内容
	addSpecialContent:(data) => post('?c=d_admin_index&m=addSpecialContent',data),
	// 删除专题内内容
	delContent:(data) => post('?c=d_three_api&m=delContent ',data),
	// // 编辑内容绑定数据
	// updateSpecialContent1:(data) => get('?c=d_three_api&m=updateSpecialContent&id='+data.id),
	// // 编辑内容提交
	// updateSpecialContent:(data) => post('?c=d_three_api&m=updateSpecialContent',data),
		// 编辑内容绑定数据
		updateSpecialContent1:(data) => get('?c=d_admin_index&m=updateSpecialContent&id='+data.id),
		// 编辑内容提交
		updateSpecialContent:(data) => post('?c=d_admin_index&m=updateSpecialContent',data),
	// 新增专题内专栏
	addSpecialColumn:(data) => post('?c=d_three_api&m=addSpecialColumn ',data),
	
	// 在线考试列表
	assessmentList:(data) => post('?c=d_three_api&m=assessmentList ',data),
	// 在线考试新增
	addAssessment:(data) => post('?c=d_three_api&m=addAssessment ',data),
	// 在线考试编辑绑定
	updateAssessment1:(data) => get('?c=d_three_api&m=updateAssessment&id='+data.id),
	// 在线考试编辑
	updateAssessment:(data) => post('?c=d_three_api&m=updateAssessment ',data),
	// 在线考试详情
	selectAssessment:(data) => post('?c=d_three_api&m=selectAssessment ',data),
	// 在线考试参与人员
	selectAssessmentUser:(data) => post('?c=d_three_api&m=selectAssessmentUser ',data),
	// 删除在线考试
	delassessment:(data) => post('?c=d_three_api&m=delassessment ',data),
	// 新增试卷
	addTest:(data) => post('?c=d_three_api&m=addTest ',data),
	// 删除试卷
	delTest:(data) => post('?c=d_three_api&m=delTest ',data),
	// 编辑试卷绑定
	updateTest:(data) => get('?c=d_three_api&m=updateTest&id='+data.id),
	// 编辑试提交
	updateTest1:(data) => post('?c=d_three_api&m=updateTest ',data),
	
	// 试题管理列表
	questionClassList:(data) => post('?c=d_three_api&m=questionClassList ',data),
	// 新增试题分类
	addQuestionClass:(data) => post('?c=d_three_api&m=addQuestionClass ',data),
	// 删除试题分类
	delQuestionClass:(data) => post('?c=d_three_api&m=delQuestionClass ',data),
	// 试题题干列表
	questionList:(data) => post('?c=d_three_api&m=questionList ',data),
	// 删除题干
	delQuestion:(data) => post('?c=d_three_api&m=delQuestion ',data),
	// 全部试题题干列表
	allQuestionList:(data) => post('?c=d_three_api&m=allQuestionList ',data),
	// 新增题干
	addQuestion:(data) => post('?c=d_three_api&m=addQuestion ',data),
	// 编辑题干
	updateQuestion1:(data) => post('?c=d_three_api&m=updateQuestion ',data),
	// 编辑题干绑定数据
	updateQuestion:(data) => get('?c=d_three_api&m=updateQuestion&id='+data.id),
	// 试卷列表
	testList:(data) => post('?c=d_three_api&m=testList ',data),
	// 新增随即组卷
	randomTest:(data) => post('?c=d_three_api&m=randomTest ',data),
	// 公开试题
	openQuestionClass:(data) => post('?c=d_three_api&m=openQuestionClass',data),

	// 随堂测试
	updateSpecialTest:(data) => post('?c=d_three_api&m=updateSpecialTest ',data),
}

// 日常办公
export const rcbg = {
	// 上级通知
	notice:(data) => post('?c=d_three_api&m=notice ',data),
	// 我发布的通知
	myNotice:(data) => post('?c=d_three_api&m=myNotice ',data),
	// 通知详情
	noticeDetail:(data) => post('?c=d_three_api&m=noticeDetail ',data),
	// 新增通知
	pubNotice:(data) => post('?c=d_three_api&m=pubNotice ',data),
	// 查看汇报
	updateMyNotice:(data) => get('?c=d_three_api&m=updateMyNotice&id='+data.id+'&zbid='+data.zbid+'&flag='+data.flag),
	// 下级汇报
	suboNotice:(data) => post('?c=d_three_api&m=suboNotice ',data),
	// 删除通知、回报
	delNotice:(data) => post('?c=d_three_api&m=delNotice ',data),
	// 消息列表
	information:(data) => post('?c=d_three_api&m=information ',data),
	// 消息一键已读
	allRead:(data) => post('?c=d_three_api&m=allRead ',data),
	// 消息详情
	informationDetail:(data) => post('?c=d_three_api&m=informationDetail ',data),
	// 删除消息
	delInformation:(data) => post('?c=d_three_api&m=delInformation ',data),
}

// 党建共建
export const dqgj = {
	// 党建共建列表
	dqgjList:(data) => post('?c=d_three_api&m=buildList',data),
	// 新增党建共建
	dqgjAdd:(data) => post('?c=d_three_api&m=addBuild',data),
	// 编辑党建共建
	dqgjUpdate:(data) => post('?c=d_three_api&m=updateBuild',data),
	// 编辑党建共建
	dqgjUpdateGet:(data) => get('?c=d_three_api&m=updateBuild&id='+data.id),
	// 删除党建共建
	dqgjDel:(data) => post('?c=d_three_api&m=delBuild',data),
}



// 系统设置
export const xtsz = {
	// 登录日志
	loginLog:(data) => post('?c=d_three_api&m=loginLog ',data),
	// 禁用账号党组织
	startDisable:(data) => post('?c=d_three_api&m=startDisable ',data),
	// 重置组织账号
	rePwd:(data) => post('?c=d_three_api&m=rePwd ',data),
	// 禁用账号党员
	updateMemberStatu:(data) => post('?c=d_three_api&m=updateMemberStatu ',data),
	// 重置党员账号
	resetUserPwd:(data) => post('?c=d_three_api&m=resetUserPwd ',data),
	// 修改密码
	updatePwd:(data) => post('?c=d_three_api&m=updatePwd ',data),
	// 修改logo
	setLogo:(data) => post('?c=d_three_api&m=setLogo ',data),
	// 修改logo
	selectLogo:(data) => post('?c=d_three_api&m=selectLogo ',data),
	// 同步过期时间
	synchroTime:(data) => post('?c=d_three_api&m=synchroTime ',data),
}